<template>
  <el-dialog
    title="Banner 详情"
    :visible.sync="visible"
    width="750px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <div v-if="model.id">
      <div class="commodity-content" v-html="model.content"></div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: false,
    }
  },
}
</script>

<style scoped>
/deep/.commodity-content img {
  width: 100%;
}
</style>